import { z } from 'zod';

export const cropVideoResponseSchema = z.object({
  localPath: z.string(),
  durationMs: z.number(),
  fileSizeKb: z.number(),
  verticalLocalPath: z.string().nullable().optional(),
  verticalFileSizeKb: z.number().nullable().optional(),
  reframeError: z.string().nullable().optional(),
});

export type ICropVideoResponse = z.infer<typeof cropVideoResponseSchema>;
